import React from "react";
import ReactMarkdown from "react-markdown";
import { colors } from "@utils/styles";
export default function MarkdownContent(props) {
	const className = props.className;
	const style = props.style ? props.style : {};
	return (
		<ReactMarkdown
			components={{
				p: ({ node, ...props }) => {
					return <p style={style} className={className} {...props} />;
				},
			}}
		>
			{props.markdown}
		</ReactMarkdown>
	);
}
